import { InvoiceState } from '@allocab/allocab-invoice-service-types';

import { BadgeIndicator, IndicatorVariant } from '../../components/BadgeIndicator';
import { t } from '../../services/translation/translation';
import { assertNever } from '../../utils/common';

type Props = {
  state: InvoiceState;
};

const getTextForState = (state: InvoiceState) => {
  switch (state) {
    case 'DRAFT':
      return t('invoice-state.draft');
    case 'EMITTED':
      return t('invoice-state.emitted');
    case 'TO_PAY':
      return t('invoice-state.to-pay');
    case 'IN_PAYMENT':
      return t('invoice-state.in-payment');
    case 'PAID':
      return t('invoice-state.paid');
    case 'REJECTED':
      return t('invoice-state.rejected');
    case 'CANCELLED':
      return t('invoice-state.cancelled');
    default:
      assertNever(state, `[getTextForState] state unknown: ${state}`);
      return '';
  }
};

const getVariantForState = (state: InvoiceState): IndicatorVariant => {
  switch (state) {
    case 'DRAFT':
      return 'gray';
    case 'EMITTED':
      return 'blue';
    case 'TO_PAY':
      return 'pink';
    case 'IN_PAYMENT':
      return 'yellow';
    case 'PAID':
      return 'green';
    case 'REJECTED':
      return 'red';
    case 'CANCELLED':
      return 'red';
    default:
      assertNever(state, `[getTextForState] state unknown: ${state}`);
      return 'gray';
  }
};

export const InvoiceStateBadge = ({ state }: Props) => {
  return <BadgeIndicator variant={getVariantForState(state)}>{getTextForState(state)}</BadgeIndicator>;
};
